<div class="col-md-12 p-3">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <div class="row">
    <div class="col-md-3 text-left p-0">
      <div class="text-blue" *ngIf="(selfAssessmentGaps && (selfAssessmentGaps.length>0)) || (selfAssessmentT2Gaps && (selfAssessmentT2Gaps.length>0))">
        <div>{{endIndex}} out of {{totalCount}}</div>
      </div>
    </div>
    <div class="col-md-9 mb-2">
      <div class="pull-right" style="right: 20px;">
        <span class="cursor-pointer text-blue" *ngIf="commonService.checkPlanTypeAction('SAGER')"
          (click)="downloadReport()"><span class="fa fa-download"></span>
          Export Report
        </span>
        <span class="cursor-pointer fg-red pl-3" *ngIf="commonService.checkPlanTypeAction('SAGD')"
          (click)="deleteItem()"><span class="fa fa-trash"></span> Delete</span>
        <span class="text-capitalize pl-3 position-relative" dropdown #dropdown="bs-dropdown" [insideClick]="true"
          [autoClose]="false">
          <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
            Filters <span class="caret" #dropInput></span>
          </span>
          <div id="dropdown-triggers-manual" *dropdownMenu
            class="dropdown-menu self-assesmentGap-filter-dropdown px-0 py-3" role="menu"
            aria-labelledby="button-triggers-manual" style="width: 100%;">
            <div class="dropdown-filter-part">
              <app-self-assessment-filter *ngIf="templateNo != 2" (OnFilter)="OnFilter($event)"></app-self-assessment-filter>
              <app-self-assessment-t2-filter *ngIf="templateNo == 2" (OnFilterT2)="OnFilterT2($event)"></app-self-assessment-t2-filter>
              <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
            </div>
          </div>
        </span>

      </div>
      <!-- <span class="text-capitalize pl-3 pull-right" dropdown #dropdown="bs-dropdown" [insideClick]="true"
        [autoClose]="false">
        <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue float-right">
          Filters <span class="caret"></span>
        </span>
        <div class="row" style="margin-left: 0; margin-right: 0;">
          <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu col-md-12 p-3" role="menu"
            aria-labelledby="button-triggers-manual">
            <app-self-assessment-filter (OnFilter)="OnFilter($event)"></app-self-assessment-filter>
          </div>
        </div>
      </span> -->

    </div>
    <div *ngIf="templateNo != 2" class="table-responsive box-shadow table-cont body-style" #tableContent>
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
      <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
      <table class="table table-fixed table-hover mb-0 table_hoizental">
        <thead>
          <tr>
            <th class="text-center width-1pr"></th>
            <th class="width-3pr text-center" (click)="sortSelfAssessment('Id')">Id
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'Id' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'Id' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
              <!-- <i class="fa" [class.fa-sort-amount-asc]=" xyz(selfAssessmentGapFilter.SortKey,  'asc')"
              [class.fa-sort-amount-desc]=" xyz(selfAssessmentGapFilter.SortKey, 'desc')"
                aria-hidden="true">
              </i> -->
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Type')">Type
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'Type' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'Type' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Owner')">Owner
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'Owner' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'Owner' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('CreatedDateTime')">Assessment Creation Date
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'CreatedDateTime' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'CreatedDateTime' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('AssessmentLastEdited')">Assessment Last
              Edited
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'AssessmentLastEdited' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'AssessmentLastEdited' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('RuleID')">RuleID
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'RuleID' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'RuleID' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Assessor')">Assessor
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'Assessor' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'Assessor' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('GapReviewStatus')">Gap Review Status
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'GapReviewStatus' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'GapReviewStatus' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('ActionTeam')">Action Team
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'ActionTeam' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'ActionTeam' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('ActionOwner')">Action Owner
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'ActionOwner' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'ActionOwner' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('ActionDueDate')">Action Due Date
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'ActionDueDate' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'ActionDueDate' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('ActionStatus')">Action Status
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'ActionStatus' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'ActionStatus' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <!-- <th class="width-6pr text-center" (click)="sortSelfAssessment('ClosureRationale')">Closure Rationale
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'ClosureRationale' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'ClosureRationale' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th> -->
            <th class="width-6pr text-center" (click)="sortSelfAssessment('AssessmentCreationDate')">Assessment Creation
              Date
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentGapFilter.SortKey === 'AssessmentCreationDate' && !selfAssessmentGapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentGapFilter.SortKey === 'AssessmentCreationDate' && selfAssessmentGapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-3pr text-center">Action</th>
          </tr>
        </thead>
        <tbody *ngIf="selfAssessmentGaps.length === 0">
          <tr>
            <td>No Data</td>
          </tr>
        </tbody>
        <tbody *ngIf="(selfAssessmentGaps && (selfAssessmentGaps.length > 0))" [style.max-height.px]="myInnerHeight">
          <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
            (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
            *ngIf="selfAssessmentGaps.length > 0">
            <div *cdkVirtualFor="let item of selfAssessmentGaps; let i = index">
              <tr
                [ngClass]="{'highlighted-row': shouldHighlightRow(i),'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
                (click)="selectedItemId = item.id" (dblclick)="redirectLink(item.id)">
                <td class="width-1pr text-center"><input type="checkbox" (change)="selectItem($event, item.id)" /></td>
                <td class="width-3pr tabel-td-scroll text-center">
                  <a [routerLink]="['/self-assessment/details/self/', item.id]">
                    <p class="mb-0" *ngFor="let rId of item.rulebookRuleID.split('|')">{{rId}}</p>
                  </a>
                </td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.type}}</td>
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  <div *ngIf="item.owner != null">
                    <p class="mb-0" *ngFor="let rOwner of item.owner.split('|')">{{rOwner}}</p>
                  </div>
                </td>
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  {{item.createdDateTime | date:'dd-MMM-yyyy'}}
                </td>
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  {{item.assessmentLastEdited | date:'dd-MMM-yyyy'}}
                </td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.ruleID}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.assessor}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.gapReviewStatus}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.actionTeam}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.actionOwner}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.actionDueDate | date:'dd-MMM-yyyy'}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.actionStatus}}</td>
                <!-- <td class="width-6pr text-center tabel-td-scroll">{{item.closureRationale}}</td> -->
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  {{item.createdDateTime | date:'dd-MMM-yyyy'}}
                </td>
                <td class="width-3pr text-center tabel-td-scroll"><a
                    href="/self-assessment/details/self/{{item.id}}">View</a>
                </td>
              </tr>
            </div>
          </cdk-virtual-scroll-viewport>
        </tbody>
      </table>
    </div>

    <!-- For New Template -->
    <div *ngIf="templateNo == 2" class="table-responsive box-shadow table-cont self-assesment-table" #tableContentT2>
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <table class="table table-fixed table-hover mb-0 table_hoizental">
        <thead>
          <tr>
            <th class="text-center width-1pr"></th>
            <th class="width-3pr text-center" (click)="sortSelfAssessment('Id')" style="width: 6%;">Id
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'Id' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'Id' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center"  (click)="sortSelfAssessment('Part')">Part
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'Part' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'Part' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
           
            <th class="width-3pr text-center" (click)="sortSelfAssessment('RuleID')"  style="width: 11%;">Rule Id
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'RuleID' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'RuleID' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Owner')">Rule Owner
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'Owner' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'Owner' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('AssessmentCategory')">Assessment Category
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'AssessmentCategory' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'AssessmentCategory' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('AssessmentDueDate')">Assessment Due Date
              <i class="fa"
                [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'AssessmentDueDate' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'AssessmentDueDate' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center" (click)="sortSelfAssessment('Gaps')">Limitations
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (selfAssessmentT2GapFilter.SortKey === 'Gaps' && !selfAssessmentT2GapFilter.IsDesc),
          'fa-sort-amount-desc': (selfAssessmentT2GapFilter.SortKey === 'Gaps' && selfAssessmentT2GapFilter.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="width-6pr text-center">No of limitations requiring action</th>
            <th class="width-6pr text-center">No of limitations</th>
            <th class="width-3pr text-center">Action</th>
          </tr>
        </thead>
        <tbody *ngIf="selfAssessmentT2Gaps.length === 0">
          <tr>
            <td>No Data</td>
          </tr>
        </tbody>
        <tbody *ngIf="(selfAssessmentT2Gaps && (selfAssessmentT2Gaps.length > 0))" [style.max-height.px]="myInnerHeight">
          <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
            (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
            *ngIf="selfAssessmentT2Gaps.length > 0">
            <div *cdkVirtualFor="let item of selfAssessmentT2Gaps; let i = index">
              <tr
                [ngClass]="{'highlighted-row': shouldHighlightRow(i),'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
                (click)="selectedItemId = item.id" (dblclick)="redirectLink(item.id)">
                <td class="width-1pr text-center"><input type="checkbox" (change)="selectItem($event, item.id)" /></td>
                <td class="width-3pr tabel-td-scroll text-center" style="width: 6%;">
                  <a href="/self-assessment/details/self/2/{{item.id}}">
                    <p class="mb-0" *ngFor="let rId of item.rulebookRuleID.split('|')">{{rId}}</p>
                  </a>
                </td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.part}}</td>
                <td class="width-3pr text-center tabel-td-scroll" style="width: 11%;">{{item.ruleID}}</td>
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  <div *ngIf="item.owner != null">
                    <p class="mb-0" *ngFor="let rOwner of item.owner.split('|')">{{rOwner}}</p>
                  </div>
                </td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.assessmentCategory}}</td>
                <td class="width-6pr text-center tabel-td-scroll" scope="row">
                  {{item.assessmentDueDate | date:'dd-MMM-yyyy'}}
                </td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.gaps}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.noOfGaps}}</td>
                <td class="width-6pr text-center tabel-td-scroll">{{item.noOfGapsRiskAccepted}}</td>
                <td class="width-3pr text-center tabel-td-scroll"><a
                  href="/self-assessment/details/self/2/{{item.id}}">View</a>
                </td>
              </tr>
            </div>
          </cdk-virtual-scroll-viewport>
        </tbody>
      </table>
    </div>
  </div>
</div>